import { InputComponent } from "components/components/Component";
import { SimpleInputBaseDefinition, SimpleInputBaseComponent } from "components/input/baseInputDefinition";
import { LabelElement } from "components/components/label/labelElement";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import template from "./time.hbs";
import "./time.scss";
import { TimeInputElement, initTimeInputWebComponent } from "./timeElement";

initTimeInputWebComponent();

export class TimeInput extends SimpleInputBaseComponent<TimeInputDefinition> implements InputComponent {

    public readonly componentType: string = "timeInput";

    private element: TimeInputElement;

    constructor(schema: TimeInputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        ComponentActionHelper.register(this);
        return this.view;
    }

    public renderTemplate(): Element {
        let objStyle: any = this.generateSytleAttribute();
        return super.renderTemplate(template, objStyle);
    }

    private generateSytleAttribute(): any {
        let objStyle: any = {};
        if (this.definition.labelKey == null) {
            objStyle.style = "max-width: 11ex;";
        }

        return objStyle;
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-time-input");

        const enableKeyUpFinishedTyping = (this.definition.disableFinishedTyping !== true);

        /** ATTENTION:
         * The onchange event is special for "time" inputs. It´s launched every time a digit of the field is changed
         * The major browser developers trigger onchange as soon as they detect a "valid" date in the field,
         *  even if you're still typing. So you have to be careful.
         * A better alternative would be to use a TimePicker */
        this.genericBindEvents(this.element, enableKeyUpFinishedTyping);
    }

    public getValue(): string {
        return this.element.data;
    }
    public value(v: string) {
        this.element.data = v;
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setRequired(required: boolean) {
        let inputLabel = this.view.querySelector("s6-input-label");
        if (inputLabel != null) {
            (inputLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }
}

export interface TimeInputDefinition extends SimpleInputBaseDefinition {
    seconds?: boolean;
    disableFinishedTyping?: boolean;
}
